/*
 * @Description: 
 * @Autor: cherry
 * @Date: 2022-05-19 08:34:49
 * @LastEditors: cherry
 * @LastEditTime: 2022-11-25 13:29:49
 */
import { Post, Get, Patch, Put, Delete, Download, ax } from './http';
import { type } from './interface';
import qs from 'qs';
export namespace WayBill {
    /**
    * 获取运单列表
    */
    export var getList = (query: any): Promise<any> => {
        return Get(`/msls/CarrierOrder?${qs.stringify(query)}`, {});
    };
    /**
    * 导出
    */
     export var Export = (query: any): Promise<any> => {
        return Download(`/msls/CarrierOrder/export?${qs.stringify(query)}`, {});
    };
    /**
    * 获取运单详情
    */
    export var GetDetail = (id: string): Promise<any> => {
        return Get(`/msls/CarrierOrder/${id}`, {});
    };
     /**
    * 获取运单下订单列表
    */
      export var getDdList = (query: any): Promise<any> => {
        return Get(`/msls/CarrierOrder/getorderfromcolist?${qs.stringify(query)}`, {});
    };
    /**
    * 获取评价详情
    */
     export var getEvalute = (query: any): Promise<any> => {
        return Get(`/msls/CarrierOrder/getevaluatedetail?${qs.stringify(query)}`, {});
    };
    /**
    * 获取评价详情
    */
     export var Evalute = (query: any): Promise<any> => {
        return Put(`/msls/CarrierOrder/evaluate`, query);
    };
     /**
    * 获取运单追踪列表
    */
      export var getTrackList = (query: any): Promise<any> => {
        return Get(`/msls/CarrierOrder/gettracklist?${qs.stringify(query)}`, {});
    };

    /**
     * 确认发货
     */
    export var confirmDelivery = (query: any): Promise<any> => {
        return Put(`/msls/CarrierOrder/confirmdelivery`, query);
    };

    /**
     * 待发货保存
     */
     export var saveDfh = (query: any): Promise<any> => {
        return Put(`/msls/CarrierOrder/savecoforwd?${qs.stringify(query)}`, {});
    };
    /**
     * 在途中保存
     */
     export var saveZtz = (query: any): Promise<any> => {
        return Put(`/msls/CarrierOrder/savecoforol?${qs.stringify(query)}`, {});
    };
    /**
     * 确认送达
     */
     export var confirmSd = (query: any): Promise<any> => {
        return Put(`/msls/CarrierOrder/confirmarrival?${qs.stringify(query)}`, {});
    };
    /**
     * 修改承运商信息
     */
     export var changeCys = (query: any): Promise<any> => {
        return Put(`/msls/CarrierOrder/changecarrier?${qs.stringify(query)}`, {});
    };
    /**
     * 修改运输信息
     */
     export var changeYsxx = (query: any): Promise<any> => {
        return Put(`/msls/CarrierOrder/changetransport?${qs.stringify(query)}`, {});
    };
    /**
     * 终结运单
     */
     export var endYd = (query: any): Promise<any> => {
        return Put(`/msls/CarrierOrder/end?${qs.stringify(query)}`, {});
    };

    /**
    * 获取历史定位记录
    */
     export var getHistoryLocation = (query: any): Promise<any> => {
        return Get(`/msls/Location/getlocationlist?${qs.stringify(query)}`, {});
    };

    /**
    * 获取LBS状态
    */
     export var getLbsStatus = (query: any): Promise<any> => {
        return Get(`/msls/Location/getlbsstate?${qs.stringify(query)}`, {});
    };

    /**
    * 开通LBS定位
    */
     export var DredgeLBS = (query: any): Promise<any> => {
        return Get(`/msls/Location/dredgelbs?${qs.stringify(query)}`, {});
    };

    /**
    * 智能定位
    */
     export var getzndw = (query: any): Promise<any> => {
        return Get(`/msls/Location/GetLocation?${qs.stringify(query)}`, {});
    };
    /**
     * 异常填报
     */
     export var addException = (query: any): Promise<any> => {
        return Post(`msls/Anomaly/AddAnomaly`, query);
    };
    /**
    * 在途监控
    */
     export var getOnlieCars = (query: any): Promise<any> => {
        return Get(`/msls/Location/GetIntransitMonitor?${qs.stringify(query)}`, {});
    };
    /**
     * 智能定位
     */
     export var getzndw1 = (query: any): Promise<any> => {
        return Get(`/msls/Location/LocationNow?${qs.stringify(query)}`, {});
    };
    /**
     * 删除运单
     */
     export var delyd = (query: any): Promise<any> => {
        return Put(`/msls/CarrierOrder/delete?${qs.stringify(query)}`, {});
    };
    /**
     * 关联运单
     */
     export var setRelation = (query: any): Promise<any> => {
        return Put(`/msls/CarrierOrder/SetRelation`, query);
    };
    /**
     * 获取关联运单信息
     */
     export var getRelated = (query: any): Promise<any> => {
        return Get(`/msls/CarrierOrder/GetRelateCarrierOrder?${qs.stringify(query)}`, {});
    };
    /**
     * 添加应收
     */
     export var addYs = (query: any): Promise<any> => {
        return Post(`/msls/Receivable/Add`, query);
    };
    /**
     * 编辑应收
     */
     export var editYs = (id: any,query): Promise<any> => {
        return Put(`/msls/Receivable/Edit/${id}`, query);
    };
    /**
     * 删除应收
     */
     export var delYs = (id: any): Promise<any> => {
        return Put(`/msls/Receivable/delete/${id}`, {});
    };
    /**
     * 添加应付
     */
     export var addYf = (query: any): Promise<any> => {
        return Post(`/msls/Fee/addfee`, query);
    };
    /**
     * 编辑应付
     */
     export var editYf = (query: any): Promise<any> => {
        console.log('res-->',query);        
        return Put(`/msls/Fee/updatefee`, query);
    };
    /**
     * 删除应付
     */
     export var delYf = (id: any): Promise<any> => {
        return Put(`/msls/Fee/deletefee/${id}`, {});
    };
     /**
     * 获取应收费用列表
     */
      export var getysfeelist = (carrierOrderId: any): Promise<any> => {
        return Get(`/msls/CarrierOrder/GetReceivableList/${carrierOrderId}`, {});
    };
    /**
     * 获取应付费用列表
     */
     export var getyffeelist = (carrierOrderId: any): Promise<any> => {
        return Get(`/msls/CarrierOrder/getfeelist/${carrierOrderId}`, {});
    };
}
